import { getIncrementalRevenue } from '../nudge-v2/utils/experiment-metrics';

export interface WinningExperiment {
  nudgeId: string;
  incrementalValue: number;
  rpv: number | null;
  cr: number | null;
  aov: number | null;
}

function parseUplift(value: unknown): number | null {
  if (value === null || value === undefined || value === '') return null;
  const numericValue = Number(String(value).replace(/[\s,%]/g, ''));
  return Number.isFinite(numericValue) ? numericValue : null;
}

export function getWinningExperiments(response: any, role?: unknown): {
  total: number;
  rows: WinningExperiment[];
} {
  const incentives: unknown[] = Array.isArray(response?.incentive)
    ? response.incentive
    : [];
  const winners = incentives
    .map((nudgeId, index): WinningExperiment => ({
      nudgeId: String(nudgeId ?? ''),
      incrementalValue: getIncrementalRevenue(response, index),
      rpv: parseUplift(response?.rpv?.uplift?.[index]),
      cr: parseUplift(response?.cr?.uplift?.[index]),
      aov: parseUplift(response?.aov?.uplift?.[index]),
    }))
    .filter((row) =>
      row.nudgeId && row.incrementalValue > 0 &&
      (role === 'master' || !row.nudgeId.includes('100.1000')),
    )
    .sort((a, b) => b.incrementalValue - a.incrementalValue);

  return { total: winners.length, rows: winners.slice(0, 5) };
}
